var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2TournamentPrizeRibbon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 458.397,
    height: 95.1949,
    viewBox: "0 0 458.397 95.1949",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009854",
    filter: "url(#filter0_d_0_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75267 40.2797L37.496 24.3585V84.6658L3.17231 88.0565L20.8767 65.3542L8.75267 40.2797Z",
    fill: "url(#paint0_linear_0_45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M449.644 40.3667L420.591 23.8055V84.9135L455.225 88.0572L437.52 65.3958L449.644 40.3667Z",
    fill: "url(#paint1_linear_0_45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M420.591 76.3979C420.591 76.3979 418.783 65.6508 398.548 65.6508H57.3946C42.477 65.6508 37.4946 75.103 37.4946 75.103V23.3078C37.4975 17.2342 38.4411 10.9988 42.089 6.70531C45.7368 2.41186 50.6832 -9.74823e-07 55.8406 0L401.149 0C406.305 0 411.25 2.41227 414.897 6.70611C418.543 10.9999 420.591 16.8236 420.591 22.896V76.3979Z",
    fill: "url(#paint2_linear_0_45)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_45",
    x: 0,
    y: 0,
    width: 458.397,
    height: 95.1949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.96538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.58615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_45",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_45",
    x1: 3.17231,
    y1: 56.2075,
    x2: 37.496,
    y2: 56.2075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CBF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120133,
    stopColor: "#2F9105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312452,
    stopColor: "#4AAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524002,
    stopColor: "#53BA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701897,
    stopColor: "#44A80A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884637,
    stopColor: "#2F9105"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_45",
    x1: 420.591,
    y1: 55.9313,
    x2: 455.225,
    y2: 55.9313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115363,
    stopColor: "#2F9105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298103,
    stopColor: "#44A80A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475998,
    stopColor: "#53BA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687548,
    stopColor: "#4AAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879867,
    stopColor: "#2F9105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CBF23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_45",
    x1: 37.4946,
    y1: 38.1989,
    x2: 420.591,
    y2: 38.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00477979,
    stopColor: "#4CBF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115363,
    stopColor: "#2F9105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298103,
    stopColor: "#44A80A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475998,
    stopColor: "#53BA0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687548,
    stopColor: "#4AAF0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879867,
    stopColor: "#2F9105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CBF23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2TournamentPrizeRibbon);
export default __webpack_public_path__ + "static/media/v2_tournament_prize_ribbon.2bf8cb8ee5ac9ff4b1e0c4ec07631c4a.svg";
export { ForwardRef as ReactComponent };